import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { ConvergentBillerAccountOfferingsSelector } from './customer.convergent.biller.selectors';
import { BILLER_RULE_INSTANCE_TYPE } from '../../customercare.constants';
import { EMPTY_OBJECT } from '../constants/common.constants';
var ServiceSuspendResumeModalDataSelector = function ServiceSuspendResumeModalDataSelector(state) {
  return state.customercare.serviceSuspendResumeModal;
};
export var IsloadingServiceSuspensionQuote = createImmutableSelector([ServiceSuspendResumeModalDataSelector], function (modalData) {
  return modalData.loadingQuotes;
});
export var ServicesToSuspendQuotesSelector = createImmutableSelector([ServiceSuspendResumeModalDataSelector], function (modalData) {
  return modalData.servicesToSuspend;
});
export var ServicesSuspensionQuoteFormattedSelector = createImmutableSelector([ServicesToSuspendQuotesSelector], function (servicesToSuspend) {
  var servicesDictionary = EMPTY_OBJECT;
  servicesToSuspend.forEach(function (service) {
    var oneTimeCharge = service.BillerRuleInstanceThumbnails.find(function (billerRule) {
      return billerRule.Type === BILLER_RULE_INSTANCE_TYPE.ONETIME;
    });
    var recurringCharge = service.BillerRuleInstanceThumbnails.find(function (billerRule) {
      return billerRule.Type === BILLER_RULE_INSTANCE_TYPE.RECURRING;
    });
    service.ServiceIdentifiers.forEach(function (serviceIdentifier) {
      servicesDictionary = servicesDictionary.set(serviceIdentifier, {
        oneTimeCharge: oneTimeCharge,
        recurringCharge: recurringCharge
      });
    });
  });
  return servicesDictionary;
});
export var IsBillCycleOptionEnabledSelector = createImmutableSelector([ServiceSuspendResumeModalDataSelector, ConvergentBillerAccountOfferingsSelector], function (modalData, offerings) {
  if (!modalData.selectedServiceIdentifierValues.length) {
    return true;
  }

  // check if there are any offcyle offers
  return !(offerings || []).some(function (offer) {
    return offer.Options.some(function (option) {
      return option.ServiceIdentifierValue && modalData.selectedServiceIdentifierValues.includes(option.ServiceIdentifierValue) && option.OffCycleDetail && option.OffCycleDetail.Id;
    });
  });
});